import { render, staticRenderFns } from "./DosageHospital-series.vue?vue&type=template&id=012f93d6&scoped=true&"
import script from "./DosageHospital-series.vue?vue&type=script&lang=js&"
export * from "./DosageHospital-series.vue?vue&type=script&lang=js&"
import style0 from "./DosageHospital-series.vue?vue&type=style&index=0&id=012f93d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f93d6",
  null
  
)

export default component.exports